import { RefObject, SetStateAction, useCallback } from "react";

import { useTranslation } from "react-i18next";

import { useDashboardStore } from "@/stores/useDashboardStore";
import { useDetailsStore } from "@/stores/useDetailsStore";

import useAxiosPrivate from "../../../api/hooks/useAxiosPrivate";
import { ApiResources } from "../../../api/resources";
import useResponse from "../../../shared/hooks/useResponse";

export type useGetInitialDataProps = {
  setIsLoading: (value: SetStateAction<boolean>) => void;
  setDataState: any;
  resource: ApiResources | string;
  initialized: RefObject<boolean>;
  setError?: (hasError: boolean) => void;
};

const useGetInitialData = () => {
  const { getData } = useAxiosPrivate();
  const { handleCommonError } = useResponse();

  const { t } = useTranslation();

  const { setIsInitialLoading, setIsDashboardLoading } = useDashboardStore();

  const setResetDetailsOnPageChange = useDetailsStore(
    state => state.setResetDetailsSection
  );

  const getInitialData = useCallback(
    async ({
      setIsLoading,
      setDataState,
      resource,
      initialized,
      setError
    }: useGetInitialDataProps) => {
      setError?.(false);
      try {
        setIsLoading(true);
        const response = await getData(resource);

        setDataState(response.data);
      } catch (error) {
        handleCommonError(error, t);
        setError?.(true);
      } finally {
        initialized.current = true;
        setIsLoading(false);
        setIsDashboardLoading(false);
        setIsInitialLoading(false);
        setResetDetailsOnPageChange(false);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [getData, handleCommonError]
  );
  return { getInitialData };
};

export default useGetInitialData;
